import { imgRoot } from "../constant/app-paths";
import { MenuItem } from "../model/menu-model";
import { Category } from './../model/search-base-model';

export const emptyCategory: Category = {
  id: '0',
  value: "",
  displayText: 'All',
}
export const signature: Category =
{
  id: '1',
  value: 'signature',
  displayText: 'SIGNATURE ROLLS',
}
export const vegeSushi: Category =
{
  id: '2',
  value: 'vegetarian sushi',
  displayText: 'VEGETARIAN SUSHI',
}
export const sashimi: Category =
{
  id: '3',
  value: 'sashimi',
  displayText: 'SASHIMI',
}

export const sushiBar: Category =
{
  id: '4',
  value: 'sushibar',
  displayText: 'SUSHI BAR',
}
export const combo: Category =
{
  id: '5',
  value: 'combo',
  displayText: 'COMBO MEALS',
}

export const kitchen: Category =
{
  id: '6',
  value: 'kitchen',
  displayText: 'KITCHEN',
}

export const noodle: Category =
{
  id: '7',
  value: 'noodle',
  displayText: 'NOODLE SOUP',
}

export const dessert: Category =
{
  id: '8',
  value: 'desert',
  displayText: 'DESSERT',
}

export const lunch: Category =
{
  id: '9',
  value: 'lunch',
  displayText: 'LUNCH',
}

export const appetizer: Category =
{
  id: '10',
  value: 'appetizer',
  displayText: 'APPETIZERS',
}
export const kitchenApp: Category =
{
  id: '11',
  value: 'kitchen app',
  displayText: 'KITCHEN APPETIZERS',
}

export const salad: Category =
{
  id: '12',
  value: 'salad',
  displayText: 'SALAD',
}

export const soup: Category =
{
  id: '13',
  value: 'soup',
  displayText: 'SOUP',
}

export const sushiSashimi: Category =
{
  id: '14',
  value: 'sushisashimi',
  displayText: 'SUSHI & SASHIMI',
}

export const rolls: Category =
{
  id: '15',
  value: 'rolls',
  displayText: 'ROLL OR HAND ROLL (6PCS)',
}

export const vegeRolls: Category =
{
  id: '16',
  value: 'vege rolls',
  displayText: 'VEGETARIAN ROLL (6PCS)',
}

export const menuCategoryFactory = (): { [key: string]: Category[] } => {

  return {
    productType: [
      appetizer,
      kitchenApp,
      salad,
      soup,
      sushiSashimi,
      rolls,
      vegeRolls,
      signature,
      vegeSushi,
      sashimi,
      sushiBar,
      combo,
      kitchen,
      noodle,
      dessert,
      lunch
    ]
  }
};


export const getMenuItems = (): MenuItem[] => {
  return [
    {
      id: '4.1',
      name: 'All Sashimi',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 9.95,
      description: '5 piece sashimi',
      groupText: appetizer.displayText,
      imageUrl: 'IMG_0133-min.JPG',

    },
    {
      id: '4.2',
      name: 'Tuna Tataki',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 13.95,
      description: 'Sliced tuna slightly smoked with ponzu sauce',
      groupText: appetizer.displayText,

    },

    {
      id: '5.1',
      name: 'Tuna Tartar',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 13.95,
      description: 'Seasoned tuna chopped with wasabi cream spicy sauce',
      groupText: appetizer.displayText,
      imageUrl: 'IMG_0254-min.JPG',

    },

    {
      id: '5.2',
      name: 'Yellowtail',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 12.95,
      description: 'Yellowtail sliced radish cilantro with ponzu sauce',
      groupText: appetizer.displayText,

    },

    {
      id: '5.3',
      name: 'Jalapenos Sashimi',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 16.95,
      description: 'Tuna, salmon, yellowtail, white tuna and thin sliced jalapeno pepper w/ ponzu sauce',
      groupText: appetizer.displayText,
      imageUrl: 'IMG_0084-min.JPG',
    },

    {
      id: '5.4',
      name: 'Scallop Appetizer',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 12.95,
      description: 'Seared scallop with olive oil, topped with tobiko and wasabi sauce',
      groupText: appetizer.displayText,

    },

    {
      id: '5.5',
      name: 'Avacado Boat',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 12.95,
      description: 'Stuffed avocado with snow crab in japanese mayo & mango sauce',
      groupText: appetizer.displayText,

    },
    {
      id: '5.51',
      name: 'Zuke Salmon',
      productType: [
        {
          value: appetizer.value,
        }
      ],
      price: 19.95,
      description: 'Marinated Salmon Slices',
      groupText: appetizer.displayText,

    },
    {
      id: '5.6',
      name: 'Edamame',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 5.50,
      description: 'Steamed soy bean',
      groupText: kitchenApp.displayText,

    },
    {
      id: '5.7',
      name: 'Gyoza',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 5.95,
      description: 'Japanese style pork dumplings',
      groupText: kitchenApp.displayText,

    },
    {
      id: '5.8',
      name: 'Shrimp Shumai',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 5.95,
      description: 'Fried Shrimp Dumpling',
      groupText: kitchenApp.displayText,

    },
    {
      id: '5.9',
      name: 'Yakitori',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 7.95,
      description: 'Chicken Skewers',
      groupText: kitchenApp.displayText,

    }, {
      id: '5.10',
      name: 'Skewer Combo',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 8.95,
      description: 'Shrimp, beef, chicken',
      groupText: kitchenApp.displayText,
      imageUrl: 'IMG_0274.jpg',

    }, {
      id: '5.11',
      name: 'Harumaki',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 6.50,
      description: 'Deep fried japanese sprint roll w/vegetables',
      groupText: kitchenApp.displayText,
      imageUrl: 'IMG_0238-min.JPG',

    },
    {
      id: '5.12',
      name: 'Takoyaki (4 pcs)',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 6.95,
      description: 'Takoyaki with Japanese mayonnaise and bonito flakes',
      groupText: kitchenApp.displayText,

    }, {
      id: '5.13',
      name: 'Japanese Fried Chicken',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 7.25,
      description: 'Nugget with chicken leg meat',
      groupText: kitchenApp.displayText,

    }, {
      id: '5.14',
      name: 'Crab Ragoon (6 pcs)',
      productType: [
        {
          value: kitchenApp.value,
        }
      ],
      price: 6.95,
      description: 'Crabstick, cream cheese, scallion and onion',
      groupText: kitchenApp.displayText,
      imageUrl: 'IMG_0240-min.JPG',

    },
    {
      id: '5.15',
      name: 'House Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 3.95,
      description: '',
      groupText: salad.displayText,

    }, {
      id: '6.1',
      name: 'Octopus Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 7.95,
      description: 'Octopus mixed with various vegetables',
      groupText: salad.displayText,

    }, {
      id: '6.2',
      name: 'Cucumber Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 4.95,
      description: '',
      groupText: salad.displayText,

    }, {
      id: '6.3',
      name: 'Seaweed Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 5.95,
      description: '',
      groupText: salad.displayText,

    }, {
      id: '6.4',
      name: 'Vegetable Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 6.50,
      description: 'Lettece, cucumber, asparagus, broccoli, tomato, avocado, shredded carrot',
      groupText: salad.displayText,

    },
    {
      id: '6.6',
      name: 'Seared Tuna Salad',
      productType: [
        {
          value: salad.value,
        }
      ],
      price: 12.95,
      description: 'Lettuce, 8 pcs seared tuna with wasabi spicy masago',
      groupText: salad.displayText,
      imageUrl: 'IMG_0262-min.JPG',

    },
    {
      id: '6.7',
      name: 'Miso Soup',
      productType: [
        {
          value: soup.value,
        }
      ],
      price: 3.25,
      description: 'Soy bean paste broth with scallionm seaweed bean curd.',
      groupText: soup.displayText,
      imageUrl: 'IMG_0111-min.JPG',

    },
    {
      id: '6.8',
      name: 'Seafood Soup',
      productType: [
        {
          value: soup.value,
        }
      ],
      price: 6.95,
      description: 'Assorted fish with clear broth',
      groupText: soup.displayText,

    },
    {
      id: '7.1',
      name: 'Tuna (Maguro)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 3.25,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0052-min.JPG'
    },
    {
      id: '7.2',
      name: 'White Tuna (Escolar)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0062-min.JPG'
    }, {
      id: '7.3',
      name: 'Yellowtail (Hamachi)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0063-min.JPG'
    },
    {
      id: '7.3',
      name: 'Yellowtail Belly',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 6.00,
      description: '',
      groupText: sushiSashimi.displayText,

    }, 
    {
      id: '7.4',
      name: 'Salmon (Sake)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0056-min.JPG'
    }, 
    {
      id: '7.4',
      name: 'Salmon Belly',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 4.50,
      description: '',
      groupText: sushiSashimi.displayText,

    },
    {
      id: '7.5',
      name: 'Shrimp (Ebi)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0064-min.JPG'
    }, {
      id: '7.6',
      name: 'Egg (Tamago)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0089-min.JPG',
    }, {
      id: '7.7',
      name: 'Eel (Unagi)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0077-min.JPG'
    }, {
      id: '7.8',
      name: 'Mackerel (Saba)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.75,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0094-min.JPG',

    }, {
      id: '7.9',
      name: 'Crab (Kani)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0065-min.JPG'
    }, {
      id: '7.11',
      name: 'Flying Fish Roe (Tobiko)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0105-min.JPG',

    }, {
      id: '7.12',
      name: 'Smelt Fish Roe (Masago)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0103-min.JPG',
    }, {
      id: '7.13',
      name: 'Salmon Roe (Ikura)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 3.25,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0099-min.JPG',

    }, {
      id: '7.14',
      name: 'Smoked Salmon',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,

    }, {
      id: '7.15',
      name: 'Scallop (Hotategai)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 3.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0080-min.JPG'
    }, {
      id: '7.16',
      name: 'Spicy Scallop',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 3.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0119-min.JPG',

    }, {
      id: '7.17',
      name: 'Red Clam (Hokkigai)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 3.25,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0068-min.JPG'
    }, {
      id: '7.18',
      name: 'Octopus (Tako)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0093-min.JPG',

    }, {
      id: '7.19',
      name: 'Calamari (Iko)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 2.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0071-min.JPG'
    }, {
      id: '7.20',
      name: 'Sweet Shrimp (Amaebi)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 4.50,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0069-min.JPG'
    }, {
      id: '7.21',
      name: 'Sea Urchin (Uni)',
      productType: [
        {
          value: sushiSashimi.value,
        }
      ],
      price: 10.95,
      description: '',
      groupText: sushiSashimi.displayText,
      imageUrl: 'IMG_0252-min.JPG',

    },
    {
      id: '8.1',
      name: 'Tuna Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.00,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0302.jpg',

    },
    {
      id: '8.2',
      name: 'Salmon Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.00,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0145-min.JPG',

    }, {
      id: '8.3',
      name: 'Yellowtail Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.00,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0195-min.JPG',

    }, {
      id: '8.4',
      name: 'White Tuna Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.00,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0218-min.JPG',

    }, {
      id: '8.5',
      name: 'California Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.95,
      description: 'Cucumber, Avacado, crabmeat',
      groupText: rolls.displayText,

    }, {
      id: '8.6',
      name: 'Philadelphia Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.25,
      description: 'Smoked Salmon, cream cheese, scallion',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0153-min.JPG',

    }, {
      id: '8.7',
      name: 'Alaskan Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.95,
      description: 'Avacado, cucumber, Salmon',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0136-min.JPG',

    }, {
      id: '8.8',
      name: 'Tuna Avacado Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.95,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0152-min.JPG',

    }, {
      id: '8.9',
      name: 'Salmon Avacado Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.75,
      description: '',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0131-min.JPG',

    }, {
      id: '8.10',
      name: 'Spicy Tuna Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.75,
      description: 'Spicy Runa, Crunch',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0139-min.JPG',

    }, {
      id: '8.11',
      name: 'Spicy Salmon Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.75,
      description: 'Spicy Salmon, Crunch',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0220-min.JPG',

    }, {
      id: '8.12',
      name: 'Spicy Kani Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 6.95,
      description: 'Spicy Kani, Crunch',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0196-min.JPG',

    }, {
      id: '8.13',
      name: 'Spicy Yellowtail Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.95,
      description: 'Spicy Yellow tail, Crunch',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0221-min.JPG',

    }, {
      id: '8.14',
      name: 'Eel Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.25,
      description: 'Eel Avacado',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0141-min.JPG',
    }, {
      id: '8.15',
      name: 'Spicy Scallop Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 9.95,
      description: 'Spicy, Scallop, Crunchy, cucumber',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0132-min.JPG',

    }, {
      id: '8.16',
      name: 'Shrimp Tempura Roll (5 pcs)',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 8.25,
      description: 'Shrimp tempura, avacado, cucumber, masago w. eel sauce',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0225-min.JPG',

    }, {
      id: '8.17',
      name: 'American Roll (5 pcs)',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 8.25,
      description: 'Shrimp tempura, avacado, cucumber masago, eel with eel sauce',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0226-min.JPG',

    }, {
      id: '8.18',
      name: 'Jalapeno Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 7.55,
      description: 'Yellowtail, Jalapeno & avacado',
      groupText: rolls.displayText,
      imageUrl: 'IMG_0156-min.JPG',

    }, {
      id: '8.19',
      name: 'Snow Crab Roll',
      productType: [
        {
          value: rolls.value,
        }
      ],
      price: 9.25,
      description: 'Japnese mayo, snow crab, crunch',
      groupText: rolls.displayText,

    },
    {
      id: '9.1',
      name: 'Avacado Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 4.95,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0161-min.JPG',

    },
    {
      id: '9.2',
      name: 'Oshinko Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 4.75,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0222-min.JPG',

    }, {
      id: '9.3',
      name: 'Cucumber Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 4.75,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0269.jpg',

    }, {
      id: '9.4',
      name: 'Asparagus Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 4.95,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0209-min.JPG',

    }, {
      id: '9.5',
      name: 'Peanut & Avacado Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 5.95,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0178-min.JPG',

    }, {
      id: '9.6',
      name: 'Sweet Potato Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 5.95,
      description: '',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0155-min.JPG',

    }, {
      id: '9.7',
      name: 'Vegetable Roll',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 5.95,
      description: 'Avacado, cucumber & carrots',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0184-min.JPG',

    }, {
      id: '9.8',
      name: 'Futo Maki',
      productType: [
        {
          value: vegeRolls.value,
        }
      ],
      price: 7.25,
      description: 'Cucumber, Avocado, Oshinko, tofu skin, egg',
      groupText: vegeRolls.displayText,
      imageUrl: 'IMG_0276.jpg',

    },
    {
      id: '1',
      name: 'Twins Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Spicy crunch tuna topped with spicy salmon',
      groupText: signature.displayText,
      imageUrl: 'IMG_0175-min.JPG',

    },
    {
      id: '2',
      name: 'Volcano Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Tuna, salmon, topped with spicy tune, spicy salmon',
      groupText: signature.displayText,
      imageUrl: 'IMG_0216-min.JPG',

    },
    {
      id: '3',
      name: 'Chicago Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Salmon,cucumber topped with eel, crunch, masago & eel sauce',
      groupText: signature.displayText,

    },
    {
      id: '4',
      name: 'Under Controll Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Spicy tuna with a hit of crunch, and shrimp tempura topped with eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0188-min.JPG',

    },
    {
      id: '5',
      name: 'Fusion Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Cucumber, crab, avocado topped with tuna & salmon roe',
      groupText: signature.displayText,
      imageUrl: 'IMG_0229-min.JPG',

    },
    {
      id: '6',
      name: 'Godzilla Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 13.95,
      description: 'Deep fried spicy tuna and spicy salmon topped with spicy mayo and eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0017-min.JPG'
    },
    {
      id: '7',
      name: 'Valentines Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 17.95,
      description: 'Spicy Tuna inside, tuna outside in heart shape',
      groupText: signature.displayText,
      imageUrl: 'IMG_0264.jpg',

    },
    {
      id: '8',
      name: "Jewelers's Roll (10 Pcs)",
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 19.95,
      description: "Lobster tempura with avacado. lettuces, white tuna on top with chef's sauce",
      groupText: signature.displayText,

    },
    {
      id: '9',
      name: 'Lion Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 16.95,
      description: 'Yellowtail cilantro, jalapeno, cucumber topped with crunch and kani and wasabi mayo, spicy salmon',
      groupText: signature.displayText,
      imageUrl: 'IMG_0295.jpg',

    },
    {
      id: '10',
      name: 'Pink Lady (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 15.95,
      description: 'Shrimp Tempura, cream cheese, avacado with soy wrap',
      groupText: signature.displayText,
      imageUrl: 'IMG_0303.jpg',

    },
    {
      id: '11',
      name: 'Green Dragon Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Eel, cucumber inside topped with avacado, crunch and eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0210-min.JPG',

    },
    {
      id: '12',
      name: 'Rainbow Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Crab, avacado, cucumber inside topped with white tuna, salmon, yellowtail, shrimp and avocado',
      groupText: signature.displayText,
      imageUrl: 'IMG_0011-min.JPG'

    },
    {
      id: '13',
      name: 'Salmon Lover (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 13.95,
      description: 'Salmon, avacado, topped with salmon yumyum sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0190-min.JPG',

    },
    {
      id: '13.1',
      name: 'Angel Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Shrimp tempura topped with crab, avacado, crunch and eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0170-min.JPG',

    },
    {
      id: '13.2',
      name: 'Pop Up Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 11.95,
      description: 'Spicy salmon, crab, shrimp, cucumber, avacado',
      groupText: signature.displayText,

    },
    {
      id: '13.3',
      name: 'Crazy Tuna Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Pepper tuna, avacado topped with spicy tuna',
      groupText: signature.displayText,
      imageUrl: 'IMG_0284.jpg',

    },
    {
      id: '13.4',
      name: 'Supersonic Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 13.95,
      description: 'Spicy scallop crunch, cucumber topped with eel, avacado, tobiko and eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0308.jpg',

    },
    {
      id: '13.5',
      name: 'Red Dragon Roll(8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 14.95,
      description: 'Soft shell crab, cucumber topped with eel, avacado, tobiko, eel sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0006-min.JPG'
    },
    {
      id: '13.6',
      name: 'Dynamite (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Cream cheese, spicy tuna, topped with spicy kani',
      groupText: signature.displayText,
      imageUrl: 'IMG_0185-min.JPG',

    },
    {
      id: '13.7',
      name: 'Mountain Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Avacado, cucumber, asparagus topped with tuna, scallion, spicy mayo',
      groupText: signature.displayText,
      imageUrl: 'IMG_0192-min.JPG',

    },
    {
      id: '13.8',
      name: 'Sunny Roll (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 13.95,
      description: 'Salmon, white tuna, yellowtail topped with crab, Ikura and wasabi mayo',
      groupText: signature.displayText,

    },
    {
      id: '13.9',
      name: 'Mango Dragon (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Shrimp tempura topped with mango slice and mango sauce',
      groupText: signature.displayText,
      imageUrl: 'IMG_0258.jpg',

    },
    {
      id: '13.10',
      name: 'Mango California (8 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 12.95,
      description: 'Crab, cucumber and avacado topped with mange slices and mango sauce',
      groupText: signature.displayText,

    },
    {
      id: '13.11',
      name: 'Tiger Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 15.95,
      description: 'snow crab, avocado, shrimp tempura wrapped with soy paper',
      groupText: signature.displayText,
      imageUrl: 'IMG_0014-min.JPG',
    },
    {
      id: '13.12',
      name: 'Giant Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 16.95,
      description: 'White fish, cheese and avocado inside, deep fried, Topped with spicy mayo and wasabi mayo',
      groupText: signature.displayText,

    },
    {
      id: '13.13',
      name: 'Passion Roll (10 Pcs)',
      productType: [
        {
          value: signature.value,
        }
      ],
      price: 16.95,
      description: 'Spicy Tuna, avocado, imitation crab, shrimp tempura, topped with wasabi mayo microgreens',
      groupText: signature.displayText,

    },
    {
      id: '14',
      name: 'Avacado',
      productType: [
        {
          value: vegeSushi.value,
        }
      ],
      price: 2.00,
      description: '',
      groupText: vegeSushi.displayText,
      imageUrl: 'IMG_0109-min.JPG',

    },
    {
      id: '15',
      name: 'Cucumber',
      productType: [
        {
          value: vegeSushi.value,
        }
      ],
      price: 2.00,
      description: '',
      groupText: vegeSushi.displayText,
      imageUrl: 'IMG_0107-min.JPG',

    },
    {
      id: '16',
      name: 'Seaweed',
      productType: [
        {
          value: vegeSushi.value,
        }
      ],
      price: 2.00,
      description: '',
      groupText: vegeSushi.displayText,
      imageUrl: 'IMG_0106-min.JPG',

    },
    {
      id: '17',
      name: 'Tofu Skin',
      productType: [
        {
          value: vegeSushi.value,
        }
      ],
      price: 2.00,
      description: '',
      groupText: vegeSushi.displayText,
      imageUrl: 'IMG_0088-min.JPG',
    },
    {
      id: '18',
      name: 'Regular (14 Pcs)',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 24.95,
      description: '',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0232-min.JPG',

    },
    {
      id: '19',
      name: 'Delux (18 Pcs)',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 29.95,
      description: '',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0123-min.JPG',

    },
    {
      id: '20',
      name: 'Chirashi',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 20.95,
      description: '',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0236-min.JPG',

    },
    {
      id: '21',
      name: 'Tekka Don',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 21.95,
      description: '',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0248-min.JPG',

    },
    {
      id: '19',
      name: 'Sake Don',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 18.95,
      description: '',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0197-min.JPG',

    },
    {
      id: '20',
      name: 'Sushi Sashimi Combo',
      productType: [
        {
          value: sashimi.value,
        }
      ],
      price: 25.95,
      description: '5 pcs sushi, 8 pcs sashimi and California Roll',
      groupText: sashimi.displayText,
      imageUrl: 'IMG_0146-min.JPG',

    },
    {
      id: '21',
      name: 'Sushi Regular',
      productType: [
        {
          value: sushiBar.value,
        }
      ],
      price: 20.95,
      description: '7 pcs + California Roll',
      groupText: sushiBar.displayText,
      imageUrl: 'IMG_0281.jpg',

    },
    {
      id: '22',
      name: 'Sushi Delux',
      productType: [
        {
          value: sushiBar.value,
        }
      ],
      price: 25.95,
      description: '10 pcs + Spicy Tuna Roll',
      groupText: sushiBar.displayText,
      imageUrl: 'IMG_0277.jpg',

    },
    {
      id: '23',
      name: 'A. Maki Combination',
      productType: [
        {
          value: combo.value,
        }
      ],
      price: 34.00,
      description: 'Spicy Tuna, Spicy Salmon, Shrimp tempura & Green Dragon',
      groupText: combo.displayText,
      imageUrl: 'IMG_0315.jpg',

    },
    {
      id: '24',
      name: 'B. Love Boat for Two',
      productType: [
        {
          value: combo.value,
        }
      ],
      price: 68.00,
      description: '10 pcs sushi, 12 pcs sashimi with California Roll and Shrimp Tempura Roll',
      groupText: combo.displayText,
      imageUrl: 'IMG_0113-min.JPG',

    },
    {
      id: '25',
      name: 'C. Love Boat for Four',
      productType: [
        {
          value: combo.value,
        }
      ],
      price: 105.00,
      description: "16 pcs sushi, and 20 pcs sashimi, Spicy Tuna Roll, American Roll and a roll of chef's Selection",
      groupText: combo.displayText,
    },
    {
      id: '26',
      name: 'D. Ryo Sushi Platter',
      productType: [
        {
          value: combo.value,
        }
      ],
      price: 119.00,
      description: '12 pcs sushi, and 18 pcs sashimi with Godzilla Roll, Dynamite Roll, Rainbow Roll, California Roll And Shrimp Tempura Roll',
      groupText: combo.displayText,

    },
    {
      id: '27',
      name: 'Beef Teriyaki',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 20.95,
      description: '',
      groupText: kitchen.displayText,

    },
    {
      id: '28',
      name: 'Chicken Teriyaki',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 15.95,
      description: '',
      groupText: kitchen.displayText,

    }, {
      id: '29',
      name: 'Salmon Teriyaki',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 17.95,
      description: '',
      groupText: kitchen.displayText,

    }, {
      id: '30',
      name: 'Una Don',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 18.95,
      description: 'Broiled eel over riace served in box',
      groupText: kitchen.displayText,

    },
    {
      id: '31',
      name: 'Gyuniku Don',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 17.95,
      description: 'Marinated fatty beef and onions over rice',
      groupText: kitchen.displayText,

    }, {
      id: '32',
      name: 'Shrimp Tempura',
      productType: [
        {
          value: kitchen.value,
        }
      ],
      price: 14.95,
      description: '',
      groupText: kitchen.displayText,

    },
    {
      id: '33',
      name: 'Seafood Udon',
      productType: [
        {
          value: noodle.value,
        }
      ],
      price: 14.95,
      description: '',
      groupText: noodle.displayText,

    },
    {
      id: '34',
      name: 'Beef Udon',
      productType: [
        {
          value: noodle.value,
        }
      ],
      price: 14.95,
      description: '',
      groupText: noodle.displayText,

    },
    {
      id: '35',
      name: 'Shrimp Tempura Udon',
      productType: [
        {
          value: noodle.value,
        }
      ],
      price: 13.95,
      description: '',
      groupText: noodle.displayText,

    },
    {
      id: '36',
      name: 'Vegetable Udon',
      productType: [
        {
          value: noodle.value,
        }
      ],
      price: 10.95,
      description: '',
      groupText: noodle.displayText,

    },
    {
      id: '36.1',
      name: 'Tonkatsu Ramen',
      productType: [
        {
          value: noodle.value,
        }
      ],
      price: 15.95,
      description: '',
      groupText: noodle.displayText,

    },
    {
      id: '37',
      name: 'Green Tea Ice Cream',
      productType: [
        {
          value: dessert.value,
        }
      ],
      price: 4.95,
      description: '',
      groupText: dessert.displayText,

    },
    {
      id: '38',
      name: 'Mango Ice Cream',
      productType: [
        {
          value: dessert.value,
        }
      ],
      price: 4.95,
      description: '',
      groupText: dessert.displayText,

    }, {
      id: '39',
      name: 'Green Tea Mochi',
      productType: [
        {
          value: dessert.value,
        }
      ],
      price: 3.95,
      description: '',
      groupText: dessert.displayText,

    }, {
      id: '40',
      name: 'Mango Mochi',
      productType: [
        {
          value: dessert.value,
        }
      ],
      price: 3.95,
      description: '',
      groupText: dessert.displayText,

    }, {
      id: '41',
      name: 'Strawberry Mochi',
      productType: [
        {
          value: dessert.value,
        }
      ],
      price: 3.95,
      description: '',
      groupText: dessert.displayText,

    },
    {
      id: '42',
      name: 'A. California Roll & Eel Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 11.95,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',
      imageUrl: 'IMG_0288.jpg',

    },
    {
      id: '43',
      name: 'B. Shrimp Tempura Roll & Spicy Tuna Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 13.50,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',

    },
    {
      id: '44',
      name: 'C. Spicy Tuna Roll, Spicy Salmon, Spicy Kani Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 17.95,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',

    },
    {
      id: '45',
      name: 'D. Crazy Tuna Roll & Philidelphia Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 17.50,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',
      imageUrl: 'IMG_0287.jpg',

    },
    {
      id: '46',
      name: 'E. Shrimp Tempura Roll, California Roll, Tuna Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 15.95,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',

    },
    {
      id: '47',
      name: 'F. Sashimi (12 Pcs)',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 18.95,
      description: '',
      groupText: lunch.displayText,

    },
    {
      id: '48',
      name: 'G. Sushi (8 Pcs) & Spicy Tuna Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 18.95,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',

    },
    {
      id: '49',
      name: 'Sashimi (5 pcs), Spicy Tuna Roll, Yellowtail Jalapeno Roll',
      productType: [
        {
          value: lunch.value,
        }
      ],
      price: 19.95,
      description: '',
      groupText: lunch.displayText,
      sectionDescription: '11 AM - 3: 30 PM',

    },



  ]
};